import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, err) => {
        // Don't retry auth failures
        if (err instanceof ApiHttpError && err.status === 401) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export class ApiHttpError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message);
  }
}
